import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  GetService,
  getPayementhistory,
  getPayementhistorywithfilter,
  getActivecategoryplans,
} from "../../../Services/Admin/Admin";
// import Table from '../../../components/Table';
import Table from "../../../Extracomponents/Table1";
import {
  SquarePen,
  Trash2,
  PanelBottomOpen,
  Eye,
  RefreshCcw,
  IndianRupee,
  ArrowDownToLine,
} from "lucide-react";
import { image_baseurl } from "../../../../Utils/config";
import { Tooltip } from "antd";
import { fDateTime, fDateTimeH } from "../../../../Utils/Date_formate";
import { exportToCSV } from "../../../../Utils/ExportData";
import Loader from "../../../../Utils/Loader";
import Select from "react-select";

const History = () => {
  const token = localStorage.getItem("token");

  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [model, setModel] = useState(false);
  const [serviceid, setServiceid] = useState({});
  const [searchInput, setSearchInput] = useState("");
  const [viewpage, setViewpage] = useState({});
  const [ForGetCSV, setForGetCSV] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [servicedata, setServicedata] = useState([]);
  const [service, setService] = useState("");
  const [selectedService, setSelectedService] = useState(null);
  const [categoryid, setCategoryid] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryudata, setCategorydata] = useState([]);
  const [type, setType] = useState("");
  const [selectedType, setSelectedType] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);

  const [isLoading, setIsLoading] = useState(true);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getservice = useCallback(async () => {
    try {
      const response = await GetService(token);
      if (response.status) {
        setServicedata(response.data);
      }
    } catch (error) {
      console.log("Error fetching services:", error);
    }
  }, [token]);

  const getcategoryplanlist = useCallback(async () => {
    try {
      const response = await getActivecategoryplans(token);
      if (response.status) {
        setCategorydata(response.data);
      }
    } catch (error) {
      console.log("error");
    }
  }, [token]);

  useEffect(() => {
    getservice();
    getcategoryplanlist();
  }, [getservice, getcategoryplanlist]);

  const [title, setTitle] = useState({
    title: "",
    description: "",
    image: "",
    add_by: "",
  });

  // const resethandle = () => {
  //     setSearchInput("")
  //     setStartDate("")
  //     setEndDate("")
  //     setCurrentPage(1);
  // }

  const resethandle = () => {
    setSearchInput("");
    setStartDate("");
    setEndDate("");

    setType("");
    setSelectedType(null);

    setService("");
    setSelectedService(null);

    setCategoryid("");
    setSelectedCategory(null);

    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchInput, startDate, endDate]);

  const getexportfile = async () => {
    try {
      const data = {
        fromDate: startDate,
        toDate: endDate,
        search: searchInput,
        service,
        plan_category_id: categoryid,
        type,
      };
      const response = await getPayementhistory(data, token);
      if (response.status) {
        if (response.data?.length > 0) {
          const csvArr = response.data?.map((item) => ({
            Name: item.clientName || "-",
            Email: item.clientEmail || "-",
            Phone: item.clientPhoneNo || "-",
            Title: item?.planCategoryTitle || "-",
            ClientSegment:
              item?.serviceNames
                .map((statusItem) => statusItem || "N/A")
                .join(", ") || "N/A",
            OerderId: item.orderid ? item.orderid : "Make By Admin",
            PlanDiscount: item.discount || 0,
            // CouponID: item?.coupon
            //   ? `${item.coupon} (${
            //       item?.couponType
            //         ? item.couponType.charAt(0).toUpperCase() +
            //           item.couponType.slice(1)
            //         : "N/A"
            //     })`
            //   : "N/A",
CouponID: item?.coupon
  ? (() => {
      let type = item?.couponType;

      // 🔹 fallback logic
      if (!type) {
        if (item.coupon.toLowerCase().includes("flat")) {
          type = "Flat";
        } else if (item.coupon.includes("%")) {
          type = "Percentage";
        }
      }

      // 🔹 capitalize
      if (type) {
        type = type.charAt(0).toUpperCase() + type.slice(1);
        return `${item.coupon} (${type})`;
      }

      return item.coupon; // no (N/A)
    })()
  : "N/A",
            PlanAmount: item.plan_price || 0,
            Total: item?.total || "-",
            Validity: item.planDetails?.validity || "-",
            PlanStart: fDateTime(item.plan_start) || "-",
            PlanEnd: fDateTime(item.plan_end) || "-",
          }));
          exportToCSV(csvArr, "Payment History");
        } else {
          console.log("No data available.");
        }
      } else {
        console.error("Failed to fetch data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };

  const gethistory = useCallback(async () => {
    try {
      setIsLoading(true);
      const data = {
        page: currentPage,
        fromDate: startDate,
        toDate: endDate,
        search: searchInput,
        service,
        plan_category_id: categoryid,
        type,
      };
      const response = await getPayementhistorywithfilter(data, token);
      if (response.status) {
        setTotalRows(response.pagination.total);
        setClients(response.data);
      }
    } catch (error) {
      console.log("Error fetching services:", error);
    } finally {
      setIsLoading(false);
    }
  }, [
    currentPage,
    startDate,
    endDate,
    searchInput,
    service,
    categoryid,
    type,
    token,
  ]);

  useEffect(() => {
    gethistory();
  }, [gethistory]);

  const handleDownload = (row) => {
    const url = `${image_baseurl}uploads/invoice/${row.invoice}`;
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const serviceOptions = useMemo(
    () => servicedata.map(({ _id, title }) => ({ value: _id, label: title })),
    [servicedata],
  );

  const categoryOptions = useMemo(
    () => categoryudata.map(({ _id, title }) => ({ value: _id, label: title })),
    [categoryudata],
  );

  const typeOptions = useMemo(
    () => [
      { value: "plan_start", label: "Start Date" },
      { value: "plan_end", label: "End Date" },
      { value: "null", label: "Purchase Date" },
    ],
    [],
  );

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => (currentPage - 1) * 10 + index + 1,
      sortable: false,
      width: "100px",
    },
    {
      name: "Name",
      selector: (row) => row.clientName,
      sortable: true,
      width: "200px",
    },
    {
      name: "Email",
      selector: (row) => row.clientEmail,
      sortable: true,
      width: "300px",
    },
    {
      name: "Phone",
      selector: (row) => row.clientPhoneNo,
      sortable: true,
      width: "200px",
    },
    {
      name: "state",
      selector: (row) => (row.state ? row.state : "-"),
      sortable: true,
      width: "200px",
    },

    {
      name: "Title",
      selector: (row) =>
        row?.planCategoryTitle ? row?.planCategoryTitle : "N/A",
      sortable: true,
      width: "200px",
    },
    {
      name: "Client Segment",
      cell: (row) => (
        <>
          {Array.isArray(row?.serviceNames) && row.serviceNames.length > 0 ? (
            row.serviceNames.map((item, index) => (
              <span
                key={index}
                style={{
                  marginRight: "5px",
                }}
              >
                {item || "N/A"}
              </span>
            ))
          ) : (
            <span>N/A</span>
          )}
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Order_ID",
      selector: (row) => (row.orderid ? row.orderid : "Make By Admin"),
      sortable: true,
      width: "250px",
    },

    {
      name: "Plan Amount",
      selector: (row) => (
        <div>
          {" "}
          <IndianRupee style={{ width: "16px" }} />
          {row.plan_price}
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Plan Discount",
      selector: (row) => (
        <div>
          {" "}
          <IndianRupee style={{ width: "16px" }} />
          {row.discount?.toFixed(2)}
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Total Amount",
      selector: (row) => row?.total || "-",
      cell: (row) => (
        <div>
          {(row?.total).toFixed(2)}{" "}
          <span style={{ fontSize: "12px" }}>({row?.gst}% Gst Included)</span>
        </div>
      ),
      sortable: true,
      width: "250px",
    },

    {
      name: "Coupon Id",
      // selector: (row) => {
      //   if (!row.coupon) return "N/A";
      //   const type = row.couponType
      //     ? row.couponType.charAt(0).toUpperCase() + row.couponType.slice(1)
      //     : "N/A";
      //   return `${row.coupon} (${type})`;
      // },

      selector: (row) => {
  if (!row.coupon) return "N/A";

  if (!row.couponType) return row.coupon;

        const type =
          row.couponType.charAt(0).toUpperCase() +
          row.couponType.slice(1);

        return `${row.coupon} (${type})`;
      },
      sortable: true,
      width: "250px",
    },

    // {
    //     name: 'Total',
    //     selector: row => <div> <IndianRupee />{row.total}</div>,
    //     sortable: true,
    //     width: '200px',
    // },
    // {
    //     name: 'Plan Price',
    //     selector: row => row.planDetails.plan_price,
    //     sortable: true,
    // },
    {
      name: "Validity",
      selector: (row) => row.validity,
      sortable: true,
      width: "200px",
    },
    {
      name: "Plan Start",
      selector: (row) => fDateTimeH(row?.plan_start),
      sortable: true,
      width: "270px",
    },
    {
      name: "Plan End",
      selector: (row) => fDateTimeH(row?.plan_end),
      sortable: true,
      width: "270px",
    },
    {
      name: "Invoice",
      cell: (row) => (
        <>
          <div className="d-flex ">
            {row.invoice ? (
              <Link className="btn px-2" onClick={() => handleDownload(row)}>
                <Tooltip placement="top" overlay="Download">
                  <ArrowDownToLine />
                </Tooltip>
              </Link>
            ) : (
              "-"
            )}
          </div>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "200px",
    },
    // {
    //     name: 'Plan End',
    //     selector: row => new Date(row.planDetails.plan_end).toLocaleDateString(),
    //     sortable: true,
    // },
    // {
    //     name: 'Date',
    //     selector: row => fDate(row.planDetails.created_at),
    //     sortable: true,
    // },
    // {
    //     name: 'Actions',
    //     cell: row => (
    //         <>
    //             <div>
    //                 <Tooltip placement="top" overlay="View">
    //                     <Eye
    //                         data-bs-toggle="modal"
    //                         data-bs-target="#example"
    //                         onClick={() => setViewpage(row)}
    //                     />
    //                 </Tooltip>
    //             </div>

    //         </>
    //     ),
    //     ignoreRowClick: true,
    //     allowOverflow: true,
    //     button: true,
    // }
  ];

  return (
    <div>
      <div className="page-content">
        <div className="page-breadcrumb  d-flex align-items-center mb-3">
          <div className="breadcrumb-title pe-3">Payment History</div>
          <div className="ps-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard">
                    <i className="bx bx-home-alt" />
                  </Link>
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="d-sm-flex align-items-center mb-4 gap-3 justify-content-between">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control ps-5 radius-10"
                  placeholder="Search Payment History"
                  onChange={(e) => setSearchInput(e.target.value)}
                  value={searchInput}
                />
                <span className="position-absolute top-50 product-show translate-middle-y">
                  <i className="bx bx-search" />
                </span>
              </div>

              <div>
                <div
                  className="ms-sm-2 mt-2 mt-sm-0"
                  onClick={(e) => getexportfile()}
                >
                  <button
                    type="button"
                    className="btn btn-primary float-md-end"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Export To Excel"
                    delay={{ show: "0", hide: "100" }}
                  >
                    <i className="bx bxs-download" aria-hidden="true"></i>
                    Export-Excel
                  </button>
                </div>
              </div>
            </div>
            <div className="row mb-2 align-items-center">
              <div className="col-md-2 col-sm-4 mb-3 mb-sm-0">
                <label>Type</label>
                <Select
                  classNamePrefix={"my-select"}
                  options={typeOptions}
                  placeholder="Select"
                  value={selectedType}
                  onChange={(selected) => {
                    setSelectedType(selected);
                    setType(selected?.value);
                  }}
                />
              </div>

              <div className="col-md-2 col-sm-4 mb-3 mb-sm-0">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setStartDate(e.target.value)}
                  value={startDate}
                  disabled={!type}
                />
              </div>

              <div className="col-md-2 col-sm-4 mb-3 mb-sm-0">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setEndDate(e.target.value)}
                  value={endDate}
                  disabled={!type}
                />
              </div>

              <div className="col-md-2 col-sm-4 mb-3 mb-sm-0">
                <label>Service</label>
                {servicedata.length > 0 && (
                  <Select
                    classNamePrefix={"my-select"}
                    options={serviceOptions}
                    placeholder="Select"
                    value={selectedService}
                    onChange={(selected) => {
                      setSelectedService(selected);
                      setService(selected?.value);
                    }}
                  />
                )}
              </div>

              <div className="col-md-2 col-sm-4 mb-3 mb-sm-0">
                <label>Category</label>
                {categoryudata.length > 0 && (
                  <Select
                    classNamePrefix={"my-select"}
                    options={categoryOptions}
                    placeholder="Select"
                    value={selectedCategory}
                    onChange={(selected) => {
                      setSelectedCategory(selected);
                      setCategoryid(selected?.value);
                    }}
                  />
                )}
              </div>

              <div className="col-md-1 col-sm-2 ">
                <div className="refresh-icon mt-2">
                  <RefreshCcw onClick={resethandle} />
                </div>
              </div>
            </div>
            {isLoading ? (
              <Loader />
            ) : clients.length > 0 ? (
              <div className="table-responsive">
                <Table
                  columns={columns}
                  data={clients}
                  totalRows={totalRows}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            ) : (
              <div className="text-center mt-5">
                <img
                  src="/assets/images/nodata.png"
                  alt="No Records Found"
                  className="w-25"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="button-group">
        <div
          className="modal fade"
          id="example"
          tabIndex={-1}
          aria-labelledby="example"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="example"></h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <ul>
                  <li>
                    <div className="row justify-content-between">
                      <div className="col-md-6">
                        <b>Title : {viewpage?.clientName}</b>
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </li>
                  <li>
                    <div className="row justify-content-between">
                      <div className="col-md-6">
                        <b>Price aaa : {viewpage?.planDetails?.price}</b>
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </li>
                  <li>
                    <div className="row justify-content-between">
                      <div className="col-md-6">
                        <b>Validity : {viewpage?.planDetails?.validity}</b>
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </li>
                  <li>
                    <div className="row justify-content-between">
                      <div>
                        <b>
                          Description :{" "}
                          {viewpage?.planDetails?.description}{" "}
                        </b>
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </li>
                  <li>
                    <div className="row justify-content-between">
                      <div className="col-md-8">
                        {viewpage?.planDetails?.created_at ? (
                          <b>
                            Payout Date:{" "}
                            {fDateTime(viewpage.planDetails.created_at)}
                          </b>
                        ) : (
                          <b>Payout Date: Not available</b>
                        )}
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </li>

                  {/* <li>
                                        <div className="row justify-content-between">
                                            <div className="col-md-6">
                                                <b>Updated At</b>
                                            </div>
                                            <div className="col-md-6">

                                            </div>
                                        </div>
                                    </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
